import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { toastr } from "react-redux-toastr";
import { getDataFromAPI } from "../HandleAPICalls/actions";
import {
  setLoading,
  saveData,
  setActivePage,
  setDropdownLoading,
  setVMOptions,
  setVMSelectedOptions,
  setButtonLoading,
} from "./actions";
import ManufactureVariants from "./component";

const ManufactureVariantsContainer = (props) => {
  const [localData, setLocalData] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isFetching, setIsFetching] = useState(false);
  const [search, setSearch] = useState("");
  const [hitapi, setHitapi] = useState(true);

  const fetchManufactureVariants = (
    pageNum = 1,
    limit = 50,
    append = false,
    searchdata = ""
  ) => {
    if (isFetching) return; // prevent multiple calls

    const offset = searchdata ? 0 : (pageNum - 1) * limit;

    setIsFetching(true);
    props.setLoading(true);
    props.setDropdownLoading(true);
    props.setActivePage(pageNum);

    props.getDataFromAPI(
      `/mvs/all?offset=${offset}&limit=${limit}&search=${encodeURIComponent(
        searchdata
      )}`,
      "GET",
      undefined,
      (response) => {
        const list = response.list || [];
        const totalCount = response.totalCount || 0;

        setHitapi(list.length > 0);

        setLocalData((prev) => {
          const newData = append ? [...prev, ...list] : list;
          setHasMore(!(list.length === 0 || newData.length >= totalCount));
          return newData;
        });

        setIsFetching(false);
        props.saveData(response);
        props.setLoading(false);
        props.setDropdownLoading(false);
      },
      (err) => {
        setIsFetching(false);
        props.setLoading(false);
        props.setDropdownLoading(false);
        toastr.error("ERROR", err);
        console.error("❌ Fetch error:", err);
      }
    );
  };

  // Handle infinite scroll
  const handleScroll = (e) => {
    const { scrollTop, clientHeight, scrollHeight } = e.target;
    const threshold = 500;

    if (scrollTop + clientHeight >= scrollHeight - threshold) {
      if (!isFetching && props.manufactureVariant && !props.manufactureVariant.loading) {
        const nextPage = page + 1;
        setPage(nextPage);

        if (hitapi) {
          if((search=="")){
          fetchManufactureVariants(nextPage, 50, true, search);
          }
        }
      }
    }
  };

  // Initial fetch
  useEffect(() => {
    fetchManufactureVariants(1, 50, false, search);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Refetch on search change
  useEffect(() => {
    setPage(1);
    fetchManufactureVariants(1, 50, false, search);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  const loading =
    props.manufactureVariant && props.manufactureVariant.loading
      ? props.manufactureVariant.loading
      : false;

  return (
    <ManufactureVariants
      loading={loading}
      mvData={localData}
      onScrollEnd={handleScroll}
      hasMore={hasMore}
      fetchData={fetchManufactureVariants} // pass API fetch function
      search={search}
      setSearch={setSearch} // child can update search
    />
  );
};

function mapStateToProps({ manufactureVariant }) {
  return { manufactureVariant };
}

export default withRouter(
  connect(mapStateToProps, {
    getDataFromAPI,
    setLoading,
    saveData,
    setActivePage,
    setDropdownLoading,
    setVMOptions,
    setVMSelectedOptions,
    setButtonLoading,
  })(ManufactureVariantsContainer)
);



// WEBPACK FOOTER //
// ./src/Modules/ManufactureVariants/container.jsx